export default __webpack_public_path__ + "static/media/297381.482d5c37.jpg";